
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgPipesModule } from 'ngx-pipes'

import { UtilCommonModule } from 'common/util/module'
import { EntityListModule } from 'common/entityList'
import { LocaleModule } from 'common/locale/module'

import { MediaPermissionEditorComponent } from './components/mediaPermissionEditor.component'
import { MediaPermissionModalComponent } from './components/mediaPermissionModal.component'
import { SharingPermissionPresetsModalComponent } from './components/sharingPermissionPresetsModal.component'
import { SharingPermissionPresetModalComponent } from './components/sharingPermissionPresetModal.component'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    LocaleModule.forChild(),
    FormsModule,
    NgPipesModule,
    EntityListModule,
  ],
  declarations: [
    MediaPermissionEditorComponent,
    MediaPermissionModalComponent,
    SharingPermissionPresetsModalComponent,
    SharingPermissionPresetModalComponent,
  ],
  exports: [
    MediaPermissionEditorComponent,
    MediaPermissionModalComponent,
  ],
})
export class MediaPermissionsModule { }

export { MediaPermissionModalComponent }
